/* ---------------------------------------------
   Reel Carousel — reel-carousel.js
--------------------------------------------- */

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.reel-carousel-wrapper').forEach(initReelCarousel);
});

// Support Shopify theme editor re-renders
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    var wrapper = event.target.querySelector('.reel-carousel-wrapper');
    if (wrapper) initReelCarousel(wrapper);
  });
}

function initReelCarousel(wrapper) {
  var track = wrapper.querySelector('.reel-track');
  var prevBtn = wrapper.querySelector('.reel-nav--prev');
  var nextBtn = wrapper.querySelector('.reel-nav--next');
  var cards = wrapper.querySelectorAll('.reel-card');

  if (!track) return;

  function scrollAmount() {
    var card = track.querySelector('.reel-card');
    if (!card) return 300;
    var gap = 16;
    return card.getBoundingClientRect().width + gap;
  }

  function updateNavState() {
    if (!prevBtn || !nextBtn) return;
    var maxScroll = track.scrollWidth - track.clientWidth - 2;
    prevBtn.disabled = track.scrollLeft <= 0;
    nextBtn.disabled = track.scrollLeft >= maxScroll;
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });
  }

  track.addEventListener('scroll', function () {
    window.requestAnimationFrame(updateNavState);
  }, { passive: true });

  window.addEventListener('resize', updateNavState);
  updateNavState();

  // --- Video handling: autoplay when in view, pause when out of view ---
  var videos = wrapper.querySelectorAll('.reel-video');

  if ('IntersectionObserver' in window && videos.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { root: track, threshold: 0.6 });

    videos.forEach(function (video) {
      observer.observe(video);
    });
  } else {
    // Fallback: just try to play all
    videos.forEach(function (video) {
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
    });
  }

  // --- Sound toggle buttons ---
  wrapper.querySelectorAll('.reel-sound-toggle').forEach(function (btn) {
    var card = btn.closest('.reel-card');
    var video = card ? card.querySelector('.reel-video') : null;
    if (!video) return;

    var mutedIcon = btn.querySelector('.icon-muted');
    var unmutedIcon = btn.querySelector('.icon-unmuted');

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      video.muted = !video.muted;
      if (mutedIcon && unmutedIcon) {
        mutedIcon.style.display = video.muted ? '' : 'none';
        unmutedIcon.style.display = video.muted ? 'none' : '';
      }
    });
  });
}